/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManualTransportProcessInfo } from '../../models/manual-transport-process-info';

export interface GetManualTransportProcessInfo$Params {
  productionOrderId: number;
}

export function getManualTransportProcessInfo(http: HttpClient, rootUrl: string, params: GetManualTransportProcessInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ManualTransportProcessInfo>> {
  const rb = new RequestBuilder(rootUrl, getManualTransportProcessInfo.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManualTransportProcessInfo>;
    })
  );
}

getManualTransportProcessInfo.PATH = '/api/v1/ProductionOrder/{productionOrderId}/GetManualTransportProcessInfo';
